import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconUsersPlus } from "@tabler/icons-react";
import { PersonalTiendasDef } from "./PersonalTiendasDef";

export const PersonalTiendasIcon = IconUsersPlus;
export const PersonalTiendasHelpText = '* Aquí puede asignar el personal a cualquiera de las tiendas dadas de alta';

export class PersonalTiendas extends Entity<PersonalTiendasDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new PersonalTiendasDef(), parentKeys);
        this.Form = import('./PersonalTiendasForm').then((module) => module.PersonalTiendasForm);
        this.Title = "Tiendas: Asignación de personal";
        this.HelpText = PersonalTiendasHelpText;
        this.Icon = PersonalTiendasIcon;
    }
}